import * as io from "socket.io-client";

export interface ChatbotAdminSocketOptions{
    user_ip: string;
}

export class ChatbotAdminSocket{
    host: string;
    path: string;
    socket?: SocketIOClient.Socket;
    opts?: SocketIOClient.ConnectOpts;

    constructor(host: string, path?: string, opts?: SocketIOClient.ConnectOpts) {
        this.host = host;
        this.opts = opts;
        if (path) {
            this.path = path;
        } else {
            this.path = "/socket.io";
        }
    }

    connect = (options?: ChatbotAdminSocketOptions, callback?: Function) => {
        this.socket = io.connect(this.host, {
            path: this.path,
            query: { ...options},
            reconnection: true,
            reconnectionDelay: 500,
            reconnectionAttempts: Infinity,
            ...this.opts
        });

        if (callback) {
            this.on("connected", (response: object) => {
                callback(response);
            });
        }
    };

    disconnect = () => {
        if (this.socket && this.socket.connected) {
            this.socket.disconnect();
        } else {
            throw new Error("There is no connection");
        }
    };

    on = (event: string, callback: Function) => {
        if (this.socket) {
            this.socket.on(event, (response: object) => {
                callback(response);
            });
        } else {
            throw new Error("Socket connect function should be preceded");
        }
    };

    emit = (event: string, data: object) => {
        if (this.socket) {
            this.socket.emit(event, data);
        } else {
            throw new Error("There is no connection");
        }
    };
}